import React from 'react';
import { HeroDesktop } from './HeroDesktop';
import { HeroMobile } from './HeroMobile';
import { HeroProps } from './HeroDesktop';

export const Hero: React.FC<HeroProps> = (props) => {
  return (
    <>
      <div className="hidden md:block">
        <HeroDesktop {...props} />
      </div>
      <div className="block md:hidden">
        <HeroMobile {...props} />
      </div>
    </>
  );
};

export type { HeroProps } from './HeroDesktop';

